import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";

import { GlobalContext } from "../../../../contexts/GlobalContext";
/**
 * ? import loader spinner
 import LoaderSpinner from "../../general/LoaderSpinner";
 */
import axios from "axios";
import {
  keyUserId,
  keyAccessToken,
} from "../../../../assets/js/SessionStorageNames";
import { accVtex, getEnterpriseProductsVtex } from "../../../../hooks/api/vtex";
import { Redirect } from "react-router-dom";
/**
 * ! import dropdown button options
 */
import DropdownButtonOptions from "../listProducts/DropDownButtonOptions";
/**
 * ! select plugin work
 */
import PluginWork from "./PluginWork";
import FilterProduct from "./FilterProduct";
/**
 * Table styles and components
 */
import TableDashboardStyle from "../../../../assets/css/components/admin/products/TableDashboardStyle.css.js";
import Pager from "../../../general/Pager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRedo,
  faSadTear,
  faMeh,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import DropDownButtonOptionsFilter from "../listProducts/DropDownButtonsOptionsFilter";
import CardFilter from "../listProducts/CardFilter";
import SelectBrand from "./SelectBrand";
import verifyAccessRole from "../../../../assets/js/verifyAccessRole";
import Routes from "../../../../Routes";


export default function ListProducts() {
  const globalContext = useContext(GlobalContext);
  const pageItemCount = 10;


  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [currentPlugin, setCurrentPlugin] = useState("");
  const [mainPlugin, setMainPlugin] = useState("");
  const [products, setProducts] = useState(null);
  const [hasNextPage, setHasNextPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [trMsg, setTrMsg] = useState(null);
  const [redirect, setRedirect] = useState(null);
  const [numRefresh, setNumRefresh] = useState(0);
  const [filter, setFilter] = useState("");
  const [searchField, setSearchField] = useState("all"); // all, title, sku, barcode
  const [filterLinkedTo, setFilterLinkedTo] = useState("");
  const [onCbtMarketplaces, setonCbtMarketplaces] = useState(null);
  const [filterPrice, setFilterPrice] = useState("");
  const [filterStock, setFilterStock] = useState("");
  const [filterWithCompany, setFilterWithCompany] = useState(null);
  const [filterWithTaxes, setFilterWithTaxes] = useState(null);
  const [amazonMaxManufacturingTime, setAmazonMaxManufacturingTime] = useState(false);
  const [currentBrand, setCurrentBrand] = useState("");
  const [brands, setBrands] = useState([]);
  const [itemsChangeStore, setItemsChangeStore] =  useState([]);
  
useEffect(() => {
  const hasAccess = verifyAccessRole(Routes, 31);
  if(!hasAccess) {
      setRedirect(
          <Redirect to={`/admin/dashboard`} />
      )
  }
},[]);

  const additemsChangeStore = (id) => {
    const isHere = itemsChangeStore.find((e) => (e === id));
        if (isHere === undefined) {
            setItemsChangeStore([...itemsChangeStore, id]);
        } else {
          setItemsChangeStore(itemsChangeStore.filter((e) => (e !== id)))
        }
  }
  let productsTrs = (
    <tr>
      <td colSpan="7" className="text-center">
        <Spinner animation="grow" />
      </td>
    </tr>
  );

  /**
   * Handle the axios error
   * @param {Error} err The thrown error
   * @param {string} msg A message to show in the modal
   * @param {boolean} consoleLog If should log the error in the console
   */
  const handleAxiosError = (err, msg = null, consoleLog = true) => {
    if (axios.isCancel(err)) return; //Don't show axios cancel error

    if (err.response && err.response.data) {
        if (err.response.data.message) {
            globalContext.showModalWithMsg(err.response.data.message);
        } else {
            globalContext.showModalWithMsg(err.response.data);
        }
    } else if (msg) {
        globalContext.showModalWithMsg(msg);
    }

    if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
  };

  /**
   * Updates the filter and search field
   * @param {string} filterValue - The search query
   * @param {string} fieldType - The field to search in (all, title, sku, barcode)
   */
  const updateFilter = (filterValue, fieldType = "all") => {
    setFilter(filterValue);
    setSearchField(fieldType);
  };

  /**
   * Builds the filter object based on search field selection
   */
  const buildSearchFilter = () => {
    const baseFilter = {
      filterLinkedTo,
      skipVariants: true,
      filterPrice,
      filterStock,
      filterWithCompany,
      filterWithTaxes,
    };

    if (!filter) return baseFilter;

    switch (searchField) {
      case 'title':
        return { ...baseFilter, title: filter };
      case 'sku':
        return { ...baseFilter, sku: filter, variSku: filter };
      case 'barcode':
        return { ...baseFilter, barCode: filter, variBarCode: filter };
      case 'brand':
        return { ...baseFilter, brandSearch: filter };
      default: // 'all'
        return {
          ...baseFilter,
          title: filter,
          barCode: filter,
          variBarCode: filter,
          sku: filter,
          variSku: filter,
        };
    }
  };

  /**
   * Updates the provided filters
   * @param {Array} filterArray All the filters to update
   */
  const updateAllFilters = (filterArray) => {
    if (typeof filterArray["filter"] != "undefined") setFilter(filterArray["filter"]);
    if (typeof filterArray["filterLinkedTo"] != "undefined") setFilterLinkedTo(filterArray["filterLinkedTo"]);
    if (typeof filterArray["onCbtMarketplaces"] != "undefined")setonCbtMarketplaces(filterArray["onCbtMarketplaces"]);
    if (typeof filterArray["filterPrice"] != "undefined") setFilterPrice(filterArray["filterPrice"]);
    if (typeof filterArray["filterStock"] != "undefined") setFilterStock(filterArray["filterStock"]);
    if (typeof filterArray["filterWithCompany"] != "undefined") setFilterWithCompany(filterArray["filterWithCompany"]);
    if (typeof filterArray["filterWithTaxes"] != "undefined") setFilterWithTaxes(filterArray["filterWithTaxes"]);
    if (typeof filterArray["amazonMaxManufacturingTime"] != "undefined") setAmazonMaxManufacturingTime(filterArray["amazonMaxManufacturingTime"]);
  }
  /**
   * Change the current plugins and reset the plugin specific filters
   */
  const updateCurrentPlugin = (plugin) => {
    setCurrentPlugin(plugin);
    setFilterWithCompany(null);
    setSearchField('all');
  };

  /**
   * Changes the selected brand
   */
  const updateBrand = (brand) => {
    setCurrentBrand(brand);
  };

  /**
   * Loads the products list
   */
  const loadProducts = () => {
    //*Get the products
    if (!globalContext.currentEnterpriseId) {
      setProducts(null);
      setHasNextPage(false);
      setTrMsg(
        <tr>
          <td colSpan="7" className="text-center">
            Debe seleccionar una empresa <FontAwesomeIcon icon={faMeh} />
          </td>
        </tr>
      );
    } else if (!currentPlugin || currentPlugin === "") {
      setProducts(null);
      setHasNextPage(false);
      setTrMsg(
        <tr>
          <td colSpan="7" className="text-center">
            Debe seleccionar un plugin <FontAwesomeIcon icon={faMeh} />
          </td>
        </tr>
      );
      
    } else {//if we got currentEnterpriseId and currentPlugin then get the products 
      setProducts(null);
      setTrMsg(null);
      const entId = globalContext.currentEnterpriseId;

      switch (currentPlugin) {
        case "odoo":
          axios
            .get(`${process.env.REACT_APP_BACKEND_URL}/v1/odoo/${entId}`, {
              params: {
                pageNumber: currentPage,
                pageItemCount: pageItemCount,
                filter: buildSearchFilter(),
                checkIsFullyLinked: true,
                includeVariantData: true,
              },
              cancelToken: axiosCancelTokenSource.token,
              headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
              },
            })

            .then((res) => {
              const data = res.data.data;
              setHasNextPage(data.hasNextPage ?? false);
              setProducts(
                data.products.map((prod) => {
                  const variants = prod.variants || [];
                  const variBarCodeOrig = variants.map(v => v.attrib?.barCode).filter(b => b !== undefined);
                  const variBarCode = variBarCodeOrig.filter((b, bIdx) => variBarCodeOrig.indexOf(b) === bIdx);
                  const variSkuOrig = variants.map(v => v.attrib?.ref_int).filter(s => s !== undefined);
                  const variSku = variSkuOrig.filter((s, sIdx) => variSkuOrig.indexOf(s) === sIdx);


                  return {
                    id: prod._id,
                    title: prod.title,
                    price: prod.price != null ? new Intl.NumberFormat("de-DE").format(prod.price) : '-',
                    stock: prod.stock ?? 0,
                    linked: prod.linkedTo && prod.linkedTo.length > 0,
                    isFullyLinked: prod.isFullyLinked,
                    isPartiallyLinked: prod.isPartiallyLinked,
                    thumbnail:
                      (prod.thumbnail && typeof prod.thumbnail == "object" && prod.thumbnail.url) ? prod.thumbnail.url
                      : (prod.thumbnail && typeof prod.thumbnail == "string") ? `data:image/png;base64,${prod.thumbnail}`
                      : false,
                    barCode: prod.attrib?.barCode,
                    variBarCode,
                    sku: prod.attrib?.ref_int,
                    variSku,
                    hasTaxes: prod.hasTaxes,
                  };

                })
              );
            })
            .catch((err) => {
              setHasNextPage(false);
              handleAxiosError(
                err,
                err
              );
            });
          break; //End odoo

          case "fl":
          // Build Falabella-specific filter (different field names and doesn't support all filter types)
          const buildFalabellaFilter = () => {
            const baseFilter = {
              filterLinkedTo,
              skipVariants: true,
              filterPrice,
              filterStock,
              // Note: Falabella doesn't use filterWithCompany or filterWithTaxes
            };

            if (!filter) return baseFilter;

            // Map searchField to Falabella-compatible fields
            switch (searchField) {
              case 'title':
                return { ...baseFilter, title: filter };
              case 'sku':
                // Falabella uses 'sellerSku' instead of 'sku'
                return { ...baseFilter, sellerSku: filter, variSku: filter };
              case 'barcode':
                return { ...baseFilter, barCode: filter, variBarCode: filter };
              case 'brand':
                // Falabella doesn't support brandSearch - brand is set via currentBrand dropdown
                return baseFilter;
              default: // 'all'
                return {
                  ...baseFilter,
                  title: filter,
                  barCode: filter,
                  variBarCode: filter,
                  sellerSku: filter,
                  variSku: filter,
                };
            }
          };
          const falaSearchFilter = buildFalabellaFilter();
          axios
            .get(
              `${process.env.REACT_APP_BACKEND_URL}/v1/fala-product/getProducts/${entId}`,
              {
                params: {
                  pageNumber: currentPage,
                  pageItemCount: pageItemCount,
                  filter: {
                    ...falaSearchFilter,
                    brand: currentBrand,
                  },
                  checkIsFullyLinked: true,
                  includeVariantData: true,
                },
                cancelToken: axiosCancelTokenSource.token,
                headers: {
                  "x-api-key": process.env.REACT_APP_API_KEY,
                  "x-access-token": localStorage.getItem(
                    keyAccessToken
                  ),
                  "x-user-id": localStorage.getItem(keyUserId),
                },
              }
            )
            .then((res) => {
              const data = res.data.data;
              setHasNextPage(data.hasNextPage ?? false);
              if(data.products.length === 0){
                handleAxiosError(
                  'No se encontro nada',
                  "Disculpe, no tiene registrado ningun productos para falabella."
                )
              }else {
                setProducts(
                  data.products.map((prod) => {
                    const variBarCodeOrig = prod.variants.map(v => v.attrib.barCode).filter(b => b !== undefined);
                    const variBarCode = variBarCodeOrig.filter((b, bIdx) => variBarCodeOrig.indexOf(b) === bIdx);
                    const variSkuOrig = prod.variants.map(v => v.attrib.sellerSku).filter(s => s !== undefined);
                    const variSku = variSkuOrig.filter((s, sIdx) => variSkuOrig.indexOf(s) === sIdx);

                    return {
                      id: prod._id,
                      title: prod.title,
                      price: new Intl.NumberFormat("de-DE").format(prod.price),
                      stock: prod.stock,
                      linked: prod.linkedTo && prod.linkedTo.length > 0,
                      isFullyLinked: prod.isFullyLinked,
                      isPartiallyLinked: prod.isPartiallyLinked,
                      thumbnail: prod.thumbnail?.url || prod.thumbnail,
                      officialStoreId: prod.attrib.official_store_id,
                      barCode: prod.attrib.barCode,
                      variBarCode,
                      sku: prod.attrib.sellerSku,
                      variSku,
                      status: prod.attrib.status,
                    };
                  })
                )
              }
            })
            .catch((err) => {
              setHasNextPage(false);
              handleAxiosError(
                err,
                err
              );
            });
          break;

        case "ml":
          axios
            .get(
              `${process.env.REACT_APP_BACKEND_URL}/v1/ml-product/${entId}`,
              {
                params: {
                  pageNumber: currentPage,
                  pageItemCount: pageItemCount,
                  filter: {
                    ...buildSearchFilter(),
                    brand: currentBrand,
                    onCbtMarketplaces,
                    ...(amazonMaxManufacturingTime && {amazonMaxManufacturingTime : 6})
                  },
                  checkIsFullyLinked: true,
                  includeVariantData: true,
                },
                cancelToken: axiosCancelTokenSource.token,
                headers: {
                  "x-api-key": process.env.REACT_APP_API_KEY,
                  "x-access-token": localStorage.getItem(
                    keyAccessToken
                  ),
                  "x-user-id": localStorage.getItem(keyUserId),
                },
              }
            )
            .then((res) => {
              const data = res.data.data;
              setHasNextPage(data.hasNextPage ?? false);
              setProducts(
                data.products.map((prod) => {
                  const variants = prod.variants || [];
                  const variBarCodeOrig = variants.map(v => v.attrib?.barCode).filter(b => b !== undefined);
                  const variBarCode = variBarCodeOrig.filter((b, bIdx) => variBarCodeOrig.indexOf(b) === bIdx);
                  const variSkuOrig = variants.map(v => v.attrib?.sku).filter(s => s !== undefined);
                  const variSku = variSkuOrig.filter((s, sIdx) => variSkuOrig.indexOf(s) === sIdx);

                  return {
                    id: prod._id,
                    title: prod.title,
                    price: new Intl.NumberFormat("de-DE").format(prod.price),
                    stock: prod.stock,
                    linked: prod.linkedTo && prod.linkedTo.length > 0,
                    isFullyLinked: prod.isFullyLinked,
                    isPartiallyLinked: prod.isPartiallyLinked,
                    thumbnail: prod.thumbnail?.url || prod.thumbnail,
                    officialStoreId: prod.attrib.official_store_id,
                    barCode: prod.attrib.barCode,
                    variBarCode,
                    sku: prod.attrib.sku,
                    variSku,
                    status: prod.attrib.status,
                    cbtMarketplace:prod.attrib.cbtMarketplace,
                    cbt: prod.attrib.isCbt || false
                  };
                })
              );
            })
            .catch((err) => {
              setHasNextPage(false);
              handleAxiosError(
                err,
                err
              );
            });
          break; //End ml
        case "vtex":
          accVtex('GET', entId, 'idmc').then((res)=> {
            const accId = Object.values(res.data).map(item => item._id).toString()
            getEnterpriseProductsVtex(entId, accId, {
              pageNumber: currentPage,
              pageItemCount: pageItemCount,
              isLinked: filterLinkedTo === 'linked' ? true : filterLinkedTo === 'unlinked' ? false : undefined,
              search: filter || '',
            }, {
              cancelToken: axiosCancelTokenSource.token,
            })
              .then((resp) => {
                const data = resp.data.data;
                // Support hasNextPage pattern
                setHasNextPage(data.hasNextPage ?? false);
                setProducts(
                  data.products.map((prod) => {
                    return {
                      id: prod._id,
                      title: prod.title,
                      price: new Intl.NumberFormat("de-DE").format(prod.price),
                      stock: prod.stock,
                      linked: prod.linkedTo && prod.linkedTo.length > 0,
                      isFullyLinked: prod.isFullyLinked,
                      isPartiallyLinked: prod.isPartiallyLinked,
                      thumbnail: prod.thumbnail && prod.thumbnail.length > 0 ? prod.thumbnail[0] : null,
                      barCode: prod.barCode || '',
                      variBarCode: [],
                      sku: prod.sku || prod.title,
                      variSku: [],
                      status: prod.isActive ? 'active' : 'inactive',
                      vtexId: prod.vtexId,
                      categoryId: prod.categoryId,
                      brandId: prod.brandId,
                      warehouseId: prod.warehouseId
                    };
                  })
                );
              })
              .catch((err) => {
                setHasNextPage(false);
                handleAxiosError(
                  err,
                  "Disculpe, hubo un error al intentar cargar la lista de productos VTEX."
                );
              });
          })
          break; //End vtex
          case "cashea":
              axios
                .get(`${process.env.REACT_APP_BACKEND_URL}/v1/cashea-prod/get-products/${entId}`, {
                  cancelToken: axiosCancelTokenSource.token,
                  headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                  },
                  params: {
                    enterpriseId: entId,
                    name:  entId === "5f1378dcef2f752aeda16673" ? '212 GLOBAL' : '212 Global Internacional',
                    pageNumber: currentPage,
                    pageItemCount: pageItemCount,
                  }
                })
                .then((resp) => {
                  const data = Object.values(resp.data.data.products);
                  setHasNextPage(resp.data.data.hasNextPage ?? false);
                  if(data.length === 0){
                    handleAxiosError(
                      'No se encontro nada',
                    )
                  }else {
                    setProducts(
                      data.map((prod) => {
                        if(entId === "60944575461add5b1957ef8b"){
                          return {
                            id: prod._id,
                            title: prod.title,
                            price: new Intl.NumberFormat("de-DE").format(prod.price),
                            stock: prod.stock,
                            thumbnail: prod.images[0],
                            sku: prod.asin,
                          };
                        }else{
                            const variBarCodeOrig = prod.variants.map(v => v.attrib.barCode).filter(b => b !== undefined);
                            const variBarCode = variBarCodeOrig.filter((b, bIdx) => variBarCodeOrig.indexOf(b) === bIdx);
                            const variSkuOrig = prod.variants.map(v => v.attrib.sellerSku).filter(s => s !== undefined);
                            const variSku = variSkuOrig.filter((s, sIdx) => variSkuOrig.indexOf(s) === sIdx);
                            return {
                              id: prod._id,
                              title: prod.title,
                              price: new Intl.NumberFormat("de-DE").format(prod.price),
                              stock: prod.stock,
                              thumbnail: prod.thumbnail?.url,
                              officialStoreId: prod.attrib.official_store_id,
                              barCode: prod.attrib.barCode,
                              variBarCode,
                              sku: prod.attrib.ref_int,
                              variSku,
                            };
                        }
                      })
                    )
                    console.log(data)
                  }
                })
                .catch((err) => {
                  setHasNextPage(false);
                  handleAxiosError(err);
                })
              .finally(() => {
                globalContext.setLoaderPage(false);
              });
            break;
          
          case "homeCenter":
            globalContext.setLoaderPage(true);
            axios
              .get(
                `${process.env.REACT_APP_BACKEND_URL}/v1/home-center-products/search-all-products/${entId}`,
                {
                  params: {
                    pageNumber: currentPage,
                    pageItemCount: pageItemCount,
                    search: filter || '',
                  },
                  cancelToken: axiosCancelTokenSource.token,
                  headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                  },
                }
              )
              .then((res) => {
                const data = res.data.data;
                setHasNextPage(data.hasNextPage ?? false);
                if (data.products.length === 0) {
                  handleAxiosError(
                    'No se encontró nada',
                    "Disculpe, no tiene registrado ningún producto para Home Center."
                  );
                } else {
                  setProducts(
                    data.products.map((prod) => {
                      const variBarCodeOrig = prod.variants?.map(v => v.attrib?.barCode).filter(b => b !== undefined) || [];
                      const variBarCode = variBarCodeOrig.filter((b, bIdx) => variBarCodeOrig.indexOf(b) === bIdx);
                      const variSkuOrig = prod.variants?.map(v => v.attrib?.sku).filter(s => s !== undefined) || [];
                      const variSku = variSkuOrig.filter((s, sIdx) => variSkuOrig.indexOf(s) === sIdx);

                      return {
                        id: prod._id,
                        title: prod.title,
                        price: new Intl.NumberFormat("de-DE").format(prod.price || 0),
                        stock: prod.stock || 0,
                        linked: prod.linkedTo && prod.linkedTo.length > 0,
                        isFullyLinked: prod.isFullyLinked,
                        isPartiallyLinked: prod.isPartiallyLinked,
                        thumbnail: prod.thumbnail,
                        barCode: prod.attrib?.barCode,
                        variBarCode,
                        sku: prod.attrib?.sku,
                        variSku,
                        status: prod.attrib?.status,
                      };
                    })
                  );
                }
              })
              .catch((err) => {
                setHasNextPage(false);
                handleAxiosError(
                  err,
                  "Error al cargar los productos de Home Center"
                );
              })
              .finally(() => {
                globalContext.setLoaderPage(false);
              });
            break; //End homeCenter
            
            default:
              break;
      }
      
      
    }
  };

  /**
   * *Reset brand list
   */
  useEffect(() => {
    setCurrentBrand("");
  }, [currentPlugin, globalContext.currentEnterpriseId]);

  /**
   * *Load the brands list
   */
  useEffect(() => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) return;

    switch(currentPlugin){
      case 'ml':
          axios
          .get(`${process.env.REACT_APP_BACKEND_URL}/v1/ml-brand/${entId}`, {
            cancelToken: axiosCancelTokenSource.token,
            headers: {
              "x-api-key": process.env.REACT_APP_API_KEY,
              "x-access-token": localStorage.getItem(keyAccessToken),
              "x-user-id": localStorage.getItem(keyUserId),
            },
          })
          .then((resp) => {
            const brands = resp.data.data.brands;
            setBrands(brands);
          })
          .catch((err) => handleAxiosError(err));
          break
      case 'cashea':
        console.log('ent prueba', entId)
          axios
          .get(`${process.env.REACT_APP_BACKEND_URL}/v1/merchants-name/merchantsName/${entId}`, {
            cancelToken: axiosCancelTokenSource.token,
            headers: {
              "x-api-key": process.env.REACT_APP_API_KEY,
              "x-access-token": localStorage.getItem(keyAccessToken),
              "x-user-id": localStorage.getItem(keyUserId),
            },
            params: {
              enterpriseId: entId,
              name: 'cashea'
            }
              
          })
          .then((resp) => {
            const brands = resp.data.data;
            setBrands(Object.values(brands));
          })
          .catch((err) => handleAxiosError(err));  
        break
      default:
        return
      }
  }, [globalContext.currentEnterpriseId, currentPlugin]);

  /**
   * Search the user main plugin
   */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/main-plugin`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((res) => setMainPlugin(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  /**
   * Load the products list if currently is in the first page, else, set the currentPage to 1 or see for any filter changes
   */
  useEffect(() => {
    if (currentPage === 1) {
      loadProducts();
    } else {
      setCurrentPage(1);
    }
  }, [
    currentPlugin,
    currentBrand,
    globalContext.currentEnterpriseId,
    filter,
    searchField,
    filterLinkedTo,
    filterPrice,
    filterStock,
    filterWithCompany,
    filterWithTaxes,
    amazonMaxManufacturingTime,
    onCbtMarketplaces,
  ]);


  /**
   * Load the products list when the page number changes or a refresh is requested
   */
  useEffect(() => {
    loadProducts();
  }, [currentPage, numRefresh]);

  /**
   * Cancel axios requests before unmount
   */
  useEffect(() => {
    return () => {
      axiosCancelTokenSource.cancel("Canceled by unmount");
    };
    //eslint-disable-next-line
  }, []);

  /**
   * Redirect to the detail page
   * @param {string} plugin The product plugin
   * @param {string} id The product ID
   */
  const goToDetail = (plugin, id) => {
    setRedirect(
      <Redirect to={`/admin/productos/detail-products/${plugin}/${id}`} />
    );
  };
  const goToPublic = (id) => {
    setRedirect(
      <Redirect to={`/admin/productos/public-product/${id}`} />
    )
  }

  if (products) {
    if (products.length === 0) {
      productsTrs = (
        <tr>
          <td colSpan="7" className="text-center">
            No se encontraron productos que mostrar!{" "}
            <FontAwesomeIcon icon={faSadTear} />
          </td>
        </tr>
      );
    } else {
      productsTrs = products.map((prod) => {
        let mlBrandName = "";

        if (prod.officialStoreId && brands.length > 0) {
          const brand = brands.filter((b) => b.id === prod.officialStoreId);

          if (brand.length > 0) {
            mlBrandName = brand[0].name;
          }
        }

        return (
          <tr key={prod.id}>
            {/* Product Image */}
            <td className="column-image">
              {prod.thumbnail && prod.thumbnail !== "data:image/png;base64,false" ? (
                <img
                  src={prod.thumbnail}
                  alt={prod.title}
                  className="product-image"
                />
              ) : (
                <div className="image-placeholder">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14zM6 7h2v2H6V7zm0 4h2v2H6v-2zm0 4h2v2H6v-2zm4-8h8v2h-8V7zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2z"/>
                  </svg>
                </div>
              )}
            </td>

            {/* Product Title */}
            <td className="column-title">
              <a
                className="product-title"
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  goToDetail(currentPlugin, prod.id);
                }}
              >
                {prod.title}
              </a>
              {mlBrandName && (
                <div className="product-brand">{mlBrandName}</div>
              )}
            </td>

            {/* Barcode - all same color (gray) */}
            <td className="column-codes">
              <div className="code-list">
                {(prod.barCode && prod.variBarCode.indexOf(prod.barCode) === -1
                  ? [prod.barCode, ...prod.variBarCode]
                  : prod.variBarCode
                ).filter(b => b && b.trim()).map((b) => (
                  <span key={b} className="code-item barcode">
                    {b}
                  </span>
                ))}
                {/* Show message if no barcodes */}
                {(prod.variBarCode.filter(b => b && b.trim()).length === 0 && !prod.barCode) && (
                  <span className="code-item no-data">Sin código</span>
                )}
              </div>
            </td>


            {/* SKU - same style as barcodes */}
            <td className="column-codes">
              <div className="code-list">
                {(prod.sku && prod.variSku.indexOf(prod.sku) === -1
                  ? [prod.sku, ...prod.variSku]
                  : prod.variSku
                ).filter(s => s).map((v) => (
                  <span key={v.toString()} className="code-item barcode">
                    {v.toString()}
                  </span>
                ))}
                {/* Show message if no SKUs */}
                {(prod.variSku.filter(s => s).length === 0 && !prod.sku) && (
                  <span className="code-item no-data">Sin SKU</span>
                )}
              </div>
            </td>




            {/* ML Status (only for ML plugin) */}
            {currentPlugin === "ml" && (
              <td className="column-ml-status">
                <span className={`ml-status-badge ${prod.status === 'active' ? 'active' : 'paused'}`}>
                  {prod.status}
                </span>
              </td>
            )}

            {/* Sync Status */}
            <td className="column-status">
              <span
                className={`status-badge ${
                  prod.isFullyLinked
                    ? "synced"
                    : prod.isPartiallyLinked
                    ? "partial"
                    : "unlinked"
                }`}
              >
                <span className="status-dot"></span>
                {prod.isFullyLinked
                  ? "Sincronizado"
                  : prod.isPartiallyLinked
                  ? "Parcial"
                  : "Sin vincular"}
              </span>
            </td>

            {/* Actions for ML plugin */}
            {currentPlugin === "ml" && (
              <td className="column-actions">
                <input
                  className="inp-cbx"
                  style={{ display: 'none' }}
                  id={`cbx${prod.id}`}
                  type="checkbox"
                  onChange={() => additemsChangeStore(prod.id)}
                  checked={itemsChangeStore.includes(prod.id)}
                />
                <label className="cbx" htmlFor={`cbx${prod.id}`}>
                  <span>
                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                      <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                    </svg>
                  </span>
                </label>
                {!prod?.cbtMarketplace && (
                  <button className="cbt-btn" onClick={() => cbtToMarket(prod)}>
                    CBT
                  </button>
                )}
              </td>
            )}
          </tr>
        );

      });
    }
  }

  const sendDataToPublisOtheStore = (v) => {
    globalContext.setActiveModalPublicOtherStore(true);
    globalContext.setItemsPublicOtherStore(itemsChangeStore)
  }

  const cbtToMarket = (idProd) => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
        globalContext.showModalWithMsg("La empresa...");
        return;
    }
    if(!idProd.cbt) {
        globalContext.showModalWithMsg("No es de CBT");
        return;
    }
    globalContext.setLoaderPage(true);
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/ml-product/${entId}/publish-cbt-to-market`, {
        countries: [{site:"MCO"}],
        products: [idProd.id],
        status: "paused",
    }, {
        cancelToken: axiosCancelTokenSource.token,
        headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
        },
    })
    .then(resp => {console.log(resp.data); globalContext.setLoaderPage(false);}).catch(err => {handleAxiosError(err); globalContext.setLoaderPage(false);});
}

  return (
    <TableDashboardStyle>
      {redirect}

      <Container fluid>
        <Row className="mt-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="limiterHeader">
              <div className="container-header">
                <div className="ActionsContent">
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={6}
                      className="colHeader"
                    >
                      <PluginWork
                        currentPlugin={currentPlugin}
                        setCurrentPlugin={updateCurrentPlugin}
                        brands={brands}
                        currentBrand={currentBrand}
                        updateBrand={updateBrand}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={6}
                      className="colHeader"
                    >
                      <div className="search-with-refresh">
                        <FilterProduct
                          filter={filter}
                          updateFilter={updateFilter}
                          currentPlugin={currentPlugin}
                        />
                        <button
                          className="btn-refresh"
                          onClick={() => {
                            setNumRefresh(numRefresh + 1);
                          }}
                          title="Actualizar lista"
                        >
                          <FontAwesomeIcon icon={faRedo} />
                        </button>
                      </div>
                    </Col>

                    <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="colHeader"
                    >
                      <SelectBrand
                      currentPlugin={currentPlugin}
                      setCurrentPlugin={updateCurrentPlugin}
                      brands={brands}
                      currentBrand={currentBrand}
                      updateBrand={updateBrand}
                      />
                    </Col>
                    <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="colHeader d-flex justify-content-center align-items-center"
                    >
                      {
                        itemsChangeStore.length > 0 && (
                          <>
                            <button 
                            className="btn-publish-in-another-store"
                            onClick={() => sendDataToPublisOtheStore()}
                            >
                              {`Publicar ${itemsChangeStore.length} en otra tienda`}
                            </button>
                            <button 
                            className="btn-publish-in-another-store-clear"
                            onClick={() => setItemsChangeStore([])}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </>
                        )
                      }
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      sm={6}
                      md={2}
                      lg={2}
                      xl={2}
                      className="colHeader d-flex justify-content-center align-items-center"
                    >
                      <DropdownButtonOptions
                        buttonTittle="Opciones"
                        currentPlugin={currentPlugin}
                        mainPlugin={mainPlugin}
                        numRefresh={numRefresh}
                        setNumRefresh={setNumRefresh}
                        filter={filter}
                        filterLinkedTo={filterLinkedTo}
                        filterPrice={filterPrice}
                        filterStock={filterStock}
                        filterWithCompany={filterWithCompany}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      md={2}
                      lg={2}
                      xl={2}
                      className="colHeader d-flex justify-content-center align-items-center"
                    >
                      {
                        currentPlugin !== "cashea" && (
                      <DropDownButtonOptionsFilter
                        currentPlugin={currentPlugin}
                        filterLinkedTo={filterLinkedTo}
                        filterPrice={filterPrice}
                        filterStock={filterStock}
                        onCbtMarketplaces={onCbtMarketplaces}
                        filterWithCompany={filterWithCompany}
                        filterWithTaxes={filterWithTaxes}
                        amazonMaxManufacturingTime={amazonMaxManufacturingTime}
                        updateFilters={updateAllFilters}
                      />
                        )
                      }
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={4}
                      lg={4}
                      xl={4}
                      className="colHeader"
                    >
                      <CardFilter
                        currentPlugin={currentPlugin}
                        filterLinkedTo={filterLinkedTo}
                        filterPrice={filterPrice}
                        onCbtMarketplaces={onCbtMarketplaces}
                        filterStock={filterStock}
                        filterWithCompany={filterWithCompany}
                        filterWithTaxes={filterWithTaxes}
                        amazonMaxManufacturingTime={amazonMaxManufacturingTime}
                        updateFilters={updateAllFilters}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="p-0">
            <div className="limiter">
              <div className="container-table100">
                <div className="wrap-table100 col-12 mt-3">
                  <div className="table100">
                    <table>
                      <thead>
                        <tr>
                          <th className="column-image">Imagen</th>
                          <th className="column-title">Producto</th>
                          <th className="column-codes">Cód. Barras</th>
                          <th className="column-codes">SKU</th>
                          {currentPlugin === "ml" && (
                            <th className="column-ml-status">Publicación</th>
                          )}
                          <th className="column-status">Estado</th>

                          {currentPlugin === "ml" && (
                            <th className="column-actions"></th>
                          )}
                        </tr>
                      </thead>

                      <tbody>{trMsg || productsTrs}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          {products && products.length > 0 && (
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="d-flex justify-content-center"
            >
              <Pager
                handleSetPage={setCurrentPage}
                currentPage={currentPage}
                hasNextPage={hasNextPage}
              />
            </Col>
          )}

        </Row>
      </Container>
    </TableDashboardStyle>
  );
}
